import config from '@epi-config';

export const getRequestedLoadsUrl = () =>
  `${config.apiHost}/api/requested-loads`;

export const postRejectRequestedLoadUrl = id =>
  `${config.apiHost}/api/requested-loads/reject/${id}`;
